export default __webpack_public_path__ + "static/media/background.0b8ffc4d.jpg";